import { useMemo } from 'react';
const DAYS_OF_WEEK = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const useGetWeekDayName = (value = 0) => {
  return useMemo(() => {
    return DAYS_OF_WEEK[value] || '';
  }, [value]);
};

export default useGetWeekDayName;
